import Vue from "vue";
import VueRouter from "vue-router";
import LoanInstanceSelection from "../views/loanSelection/loan-instance-selection.vue";
Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    name: "engagement-tool-selection",
    component: () => import("../views/engagement-tool-selection.vue"),
  },
  {
    path: "/loan-instance-selection",
    name: "loan-instance-selection",
    component: LoanInstanceSelection,
  },
  {
    path: "/loan-engagement-tool",
    name: "loan-engagement-tool",
    component: () => import("../views/loan/loan-engagement-tool.vue"),
  },
  {
    path: "/save-engagement-tool",
    name: "save-engagement-tool",
    component: () => import("../views/loan/save-engagement-tool.vue"),
  },
  {
    path: "/investment-engagement-tool",
    name: "investment-engagement-tool",
    component: () =>
      import("../views/investment/investment-engagement-tool.vue"),
  },
  {
    path: "/save-investment-engagement-tool",
    name: "save-investment-engagement-tool",
    component: () => import("../views/investment/save-engagement-tool.vue"),
  },
  {
    path: "/compare-loan",
    name: "compare-loan",
    component: () => import("../views/loan/loan-comparing-tool.vue"),
  },
  {
    path: "/compare-investment",
    name: "compare-investment",
    component: () => import("../views/investment/investment-compare-tool.vue"),
  },
  {
    path: "/investment-instance-selection",
    name: "investment-instance-selection",
    component: () =>
      import("../views/investmentSelection/investment-instance-selection.vue"),
  },
  {
    path: "/month-picker-test",
    name: "month-picker-test",
    component: () => import("../views/investment/month-picker-test.vue"),
  },
  {
    path: "/superannuation-instance-selection",
    name: "superannuation-instance-selection",
    component: () =>
      import(
        "../views/superannuationSelection/superannuation-instance-selection.vue"
      ),
  },
  {
    path: "/superannuation-engagement-tool",
    name: "superannuation-engagement-tool",
    component: () =>
      import("../views/superannuation/superannuation-engagement-tool.vue"),
  },
  {
    path: "/save-superannuation-engagement-tool",
    name: "save-superannuation-engagement-tool",
    component: () => import("../views/superannuation/save-engagement-tool.vue"),
  },
  {
    path: "/compare-super",
    name: "compare-super",
    component: () => import("../views/superannuation/super-compare-tool.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
